
define("json!shoptheme/etc/breakpoints.json", function(){ return {
  	"mobile": 479,
  	"xs": 767,
	"sm": 991,
	"md": 1199,
	"lg": 1649
};});

